<template>
  <div
    v-if="showBanner"
    class="app_message text_align_center"
    :class="{
      bg_yellow: appMessage.severity == 'warn',
      bg_red: appMessage.severity == 'error',
      app_message_locked: sideMenuLock,
    }"
  >
    <div v-if="appMessage.closable" class="right_menu_items">
      <AppButton
        type="button"
        icon="pi pi-times"
        size="small"
        severity="secondary"
        @click="showBannerToggle"
        text
        rounded
        aria-haspopup="true"
        aria-controls="overlay_menu"
      ></AppButton>
    </div>
    <h4>
      {{ appMessage.message }}
      <router-link :to="{ name: appMessage.router }">{{
        $t("actions.click_here")
      }}</router-link>
    </h4>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      appMessage: null,
    };
  },
  computed: {
    ...mapGetters("billingData", [
      "outstandingCharges",
      "accountLocked",
      "paymentMethod",
    ]),
    ...mapGetters("userData", ["showBanner", "sideMenuLock"]),
  },
  methods: {
    ...mapActions("userData", ["showBannerToggle"]),
  },
  created() {
    // Display a message if account is locked
    if (this.accountLocked) {
      this.appMessage = {
        message: this.$t("descriptions.account_locked_banner"),
        router: "billing-and-payments",
        severity: "error",
        closable: false,
      };
      if (!this.showBanner) {
        this.showBannerToggle();
      }
    }
    // Display message if user has outstanding charges
    else if (this.outstandingCharges) {
      this.appMessage = {
        message: this.$t("descriptions.overdue_payment_banner"),
        router: "billing-and-payments",
        severity: "warn",
        closable: true,
      };
      if (!this.showBanner) {
        this.showBannerToggle();
      }
    }
    // Display a message if user has not added a payment method
    // else if(this.paymentMethod == 'No payment method'){
    //   this.appMessage = {
    //     message: this.$t("descriptions.no_payment_method_banner"),
    //     router: 'billing-and-payments',
    //     severity: 'warn',
    //     closable: true,
    //   }
    //   if(!this.showBanner){
    //     this.showBannerToggle()
    //   }
    // }
    else {
      if (this.showBanner) {
        this.showBannerToggle();
      }
    }
  },
};
</script>

<style scoped>
.app_message {
  padding: 20px;
  width: calc(100% - 70px);
  position: fixed;
  z-index: 10;
}

.app_message_locked {
  width: calc(100% - 240px);
}

/* Responsive */
@media screen and (max-width: 500px) {
  .app_message h4 {
    width: 80%;
    margin: 0 auto;
  }

  .app_message {
    position: relative;
    width: 100%;
  }

  .app_message_locked {
    width: 100%;
  }
}
</style>
